module.exports = __webpack_public_path__ + "static/img/TA.31c5be20.svg";